import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../api';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Lock, User, ArrowLeft, Loader2, Eye, EyeOff } from 'lucide-react';

export default function AdminLogin() {
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (!u.trim() || !p) { setErr('Preencha usuário e senha.'); return; }
    setBusy(true);
    try {
      await login(u.trim(), p);
      navigate('/admin', { replace: true });
    } catch (e2) {
      const detail = e2?.response?.data?.detail;
      const msg = typeof detail === 'string' ? detail : (e2?.message === 'Network Error'
        ? 'Não foi possível conectar ao servidor. Verifique sua internet.'
        : 'Usuário ou senha incorretos.');
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#faf7f2] grid place-items-center px-6 py-12">
      <div className="w-full max-w-sm">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-neutral-900 mb-6">
          <ArrowLeft size={14} /> Voltar
        </Link>

        <div className="bg-white rounded-2xl border border-neutral-200 p-7 shadow-sm">
          <div className="flex flex-col items-center text-center mb-6">
            <div className="w-12 h-12 rounded-xl bg-neutral-900 grid place-items-center text-white">
              <Lock size={20} />
            </div>
            <h1 className="mt-3 text-2xl font-bold tracking-tight">Painel Admin</h1>
            <p className="text-sm text-neutral-500 mt-1">Entre para gerenciar os biosites.</p>
          </div>

          <form onSubmit={submit} className="space-y-4" autoComplete="on" noValidate>
            <div>
              <Label htmlFor="u">Usuário</Label>
              <div className="relative mt-1">
                <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
                <Input id="u" name="username" autoComplete="username" value={u} onChange={(e) => setU(e.target.value)} placeholder="admin" className="pl-9" />
              </div>
            </div>
            <div>
              <Label htmlFor="p">Senha</Label>
              <div className="relative mt-1">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
                <Input id="p" name="password" type={showPwd ? 'text' : 'password'} autoComplete="current-password" value={p} onChange={(e) => setP(e.target.value)} placeholder="••••••" className="pl-9 pr-10" />
                <button type="button" onClick={() => setShowPwd(!showPwd)} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-neutral-400 hover:text-neutral-900" aria-label={showPwd ? 'Ocultar senha' : 'Mostrar senha'}>
                  {showPwd ? <EyeOff size={14} /> : <Eye size={14} />}
                </button>
              </div>
            </div>
            {err && <div role="alert" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-md px-3 py-2">{err}</div>}
            <Button type="submit" disabled={busy} className="w-full bg-neutral-900 hover:bg-neutral-800 text-white gap-2">
              {busy && <Loader2 className="animate-spin" size={14} />} Entrar
            </Button>
          </form>

          <div className="mt-5 text-xs text-neutral-500 bg-neutral-50 rounded-lg px-3 py-2 border border-neutral-200">
            <b>Credenciais padrão:</b> usuário <code>admin</code> / senha <code>admin123</code>
            <div className="mt-1 opacity-80">Troque em <Link to="/admin/settings" className="underline">Configurações</Link> após o primeiro login.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
